// The example invitations: animated template loops (short muted mp4s,
// ~150-650 KB each, with .jpg posters) in public/showcase. The hero plays
// them as a slideshow.
export const SHOWCASE = [
  {
    media: '/showcase/wedding-script',
    type: { en: 'Wedding', ka: 'ქორწილი' },
    label: {
      en: 'Wedding invitation example — animated template with the date, venue and RSVP',
      ka: 'ქორწილის მოსაწვევის ნიმუში — ანიმაციური შაბლონი თარიღით, ადგილითა და RSVP-თი',
    },
    rsvp: 86,
  },
  {
    media: '/showcase/birthday-ribbon',
    type: { en: 'Birthday', ka: 'დაბადების დღე' },
    label: {
      en: 'Birthday invitation example — animated template with the date, venue and RSVP',
      ka: 'დაბადების დღის მოსაწვევის ნიმუში — ანიმაციური შაბლონი თარიღით, ადგილითა და RSVP-თი',
    },
    rsvp: 42,
  },
  {
    media: '/showcase/cocktail-party',
    type: { en: 'Corporate', ka: 'კორპორატივი' },
    label: {
      en: 'Corporate event invitation example — animated template with the date, venue and RSVP',
      ka: 'კორპორატიული ღონისძიების მოსაწვევის ნიმუში — ანიმაციური შაბლონი თარიღით, ადგილითა და RSVP-თი',
    },
    rsvp: 128,
  },
  {
    media: '/showcase/kids-space',
    type: { en: 'Kids party', ka: 'საბავშვო წვეულება' },
    label: {
      en: 'Kids party invitation example — animated template with the date, venue and RSVP',
      ka: 'საბავშვო წვეულების მოსაწვევის ნიმუში — ანიმაციური შაბლონი თარიღით, ადგილითა და RSVP-თი',
    },
    rsvp: 24,
  },
]
